<template>
  <pui-flex class="poster-search-mode-selector poster-search-mode-selector__root">
    <ul>
      <li
        v-for="searchMode in items"
        :key="searchMode.itemId"
        :class="{
          selected: value && value.itemId === searchMode.itemId,
        }"
        @click="$emit('change', searchMode)"
        class="poster-search-mode-selector__mode-element"
      >
        <i class="picto mdi mdi-magnify" />
        <span>{{ piivoTranslate(searchMode) }}</span>
      </li>
    </ul>
  </pui-flex>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'poster-search-mode-selector',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Search mode items
     */
    items: {
      type: Array,
      required: true,
    },
    /**
     * The selected search mode
     */
    value: {
      type: Object,
      default: null,
    },
  },
  methods: {
    // FILTERS
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
  },
};
</script>
